export default "__VITE_ASSET__CjwR3t5k__"